import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Loader } from 'application/components';
import { DownloadIClubImage, EmptyStateIcon } from 'application/assets';
import { AmplitudeEvent, useAmplitude } from 'application/hooks/useAmplitude';
import { useAppDispatch, useAppSelector } from 'application/store';
import { AuthActions } from 'application/store/Auth/actions';
import { isResponseFulfilled } from 'application/helpers/responseHelper';
import { requestSelector } from 'application/store/request/selectors';
import { AuthSliceActions } from 'application/store/Auth/authSlice';

import { DealErrorPageProps } from './models';
import {
  ImageWrapper,
  Image,
  Wrapper,
  LogOutButton,
  ButtonsSection,
} from './styles';

const supportLink = process.env.REACT_APP_SUPPORT_URL;

const DealErrorPage: FC<DealErrorPageProps> = ({ title, description }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { trackEvent } = useAmplitude();
  const { loading } = useAppSelector(requestSelector).logout;

  const sendHelpEvent = () => {
    trackEvent(AmplitudeEvent.Help_Button);
  };

  const logout = async () => {
    const response = await dispatch(AuthActions.logout());
    isResponseFulfilled(response, () => {
      dispatch(AuthSliceActions.clearStore());
    });
  };

  return (
    <Wrapper>
      {loading && <Loader />}
      <div>
        <ImageWrapper>
          <Image>
            <img
              height={240}
              src={DownloadIClubImage}
              alt="download-icon"
              referrerPolicy="no-referrer"
            />
          </Image>
          <EmptyStateIcon />
        </ImageWrapper>
        {title && <h1>{title}</h1>}
        <p>{description}</p>
      </div>
      <ButtonsSection>
        <a href={supportLink} target="_blank" rel="noreferrer">
          <Button type="button" onClick={sendHelpEvent}>
            Contact support
          </Button>
        </a>
        <LogOutButton type="button" onClick={logout}>
          Log out
        </LogOutButton>
      </ButtonsSection>
    </Wrapper>
  );
};

export default DealErrorPage;
